import mainLogo from "../../../assets/images/svg/main-logo-for-dark-bg.svg";
import styles from "./MainIcon.module.css";

type Props = { size?: number };
export const MainIcon = ({ size = 120 }: Props) => (
  <div style={{ width: size }} className={styles.mainIcon}>
    <img src={mainLogo} alt="" />
  </div>
);
